import { Component, OnInit, ViewChild, ElementRef, AfterViewChecked } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { BREADCRUMBS } from 'config';
import { Router } from '@angular/router';
import { WelcomeService } from './welcome.service';
import { WelcomeModel } from './welcome.model';
import { AuthenticationService, UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { ConfirmModalPopupModel } from 'lib/ng2-sapmp/src/ui-components/confirm-modal';
import { UserWizardModel, UserProfileModel } from 'lib/ng2-sapmp/src/models';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { ChipsService } from 'lib/ng2-sapmp/src/ui-components/chips/chips.service';

declare var logoutCurrentUser: any;
export const ESCAPE_KEY = 27;
@Component({
  selector: 'app-signup',
  providers: [WelcomeService, AdobeAnalyticsService],
  templateUrl: './welcome.component.html',
  styleUrls: ['./welcome.component.scss']
})
export class WelcomeComponent implements OnInit, AfterViewChecked {
  header: string;
  welcome: WelcomeModel;
  isDataAvailable: boolean;
  initModal: boolean;
  showOverviewModal: boolean;
  permissionLevelMessage: string;
  errorMessage: any;
  signUpStatus: any;
  hasAccess: boolean;
  // overviewModalPopup: ConfirmModalPopupModel;
  confirmModalPopup: ConfirmModalPopupModel;
  eventEmit: any;
  modalClass: string;
  signUp: boolean;
  focusabbleElements: any;
  videoId: any;
  user: UserProfileModel;
  manageproduct: any;
  twoTwenty = false;
  videoPlaying = false;
  @ViewChild('accessModal') accessModal: ElementRef;
  constructor(private utilityService: UtilityService, private router: Router,
    private pageloaderService: PageLoaderService,
    private welcomeservice: WelcomeService, private authenticationService:
      AuthenticationService, private adobeAnalyticsService: AdobeAnalyticsService,
    private chips: ChipsService) {
    this.isDataAvailable = false;
    this.hasAccess = false;
    this.user = new UserProfileModel();
  }

  ngOnInit() {
    // document.title = 'AT&T Business Console';
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.chips.setChips([ {
      "label": "Home",
      "routerLink": "/home"
    },
    {
      "label": "Welcome",
      "routerLink": "/welcome"
    }]);
    this.user = this.authenticationService.getUser();
    this.welcomeservice.getWelcomeDetails().subscribe(response => {
      this.welcome = response;
      this.isDataAvailable = true;
      this.checkAccess();
    });
    const pageName = 'welcomePage';
    // this.welcomeservice.requestSupportContent(this.utilityService.getEnvConfig().getSupportDocument, pageName).
    //   subscribe(resp => {
    //     this.videoId = resp.supportArticles.availableArticle[0].url;
    //   });
    this.welcomeservice.createPageLoadProperties('WELCOME');

  }


  btnAction(event) {
    this.showOverviewModal = false;
    if (event) {
      this.router.navigate(['/productselection/']);
    }
  }

  closeModal() {
    this.showOverviewModal = false;
    this.initModal = false;
    setTimeout( () => {
      this.loadFocustelements(document)
    },0);
    this.welcomeservice.createPageLoadProperties('WELCOME');

  }

  openOverviewModal() {
    this.confirmModalPopup = new ConfirmModalPopupModel();
    this.showOverviewModal = true;
    this.welcomeservice.createPageLoadProperties('WELCOMEMODAL');

    setTimeout(() => { this.loadFocustelements(this.accessModal.nativeElement); });
    this.welcomeservice.requestPopupContent(this.utilityService.getEnvConfig().getSupportDocument[2]).
      subscribe(
        res => {
          // this.confirmModalPopup.modalMessage = res.content;
        });
    //this.confirmModalPopup.modalMessage = '<div ><div >Additional capabilities:</div><div></br></div><ul><li>&ensp; &ensp; •	 &ensp; Mobile device management features, the ability to: <ul><li>&ensp; &ensp; &ensp; &ensp; •	&ensp; Deploy a standard set of apps to devices</li><li> &ensp; &ensp; &ensp; &ensp; •	&ensp; Wipe or lock lost or stolen devices</li></ul></li><li> &ensp; &ensp; •	&ensp; Network restrictions</li><li>&ensp; &ensp; •	&ensp; Reports</li><li>&ensp; &ensp; •	&ensp; Alerts.</li></ul></div>';
    this.confirmModalPopup.confirmButtonMessage = 'OK';
    this.confirmModalPopup.showCancelButton = false;
    this.initModal = true;
    this.eventEmit = document.activeElement;
  }


  /* openOverviewModal() {
      this.showOverviewModal = true;
         setTimeout(() => { this.loadFocustelements(this.accessModal.nativeElement); });
   }*/
  adobeLinkClick() {
    this.adobeAnalyticsService.createClickProperties('Overview tutorial', 'Body', '/businessconsole/welcome');
  }

  ngAfterViewChecked() {
    if (this.videoPlaying) {
      const playerHeight = document.getElementById('player').clientHeight;
      if (playerHeight === 220 && this.twoTwenty) {
        // second time 220 hence video has stopped
        const player = document.getElementById('player');
        player.classList.remove('mediaPlay');
        player.classList.add('mediaStop');
        this.twoTwenty = false;
        this.videoPlaying = false;
      } else if (playerHeight === 220) {
        // first time 220
        this.twoTwenty = true;
      }
    }
  }

  playVideo() {
    const player = document.getElementById('player');
    player.classList.remove('mediaStop');
    player.classList.add('mediaPlay');
    this.videoPlaying = true;
  }


  loadFocustelements(el) {
    if (!this.focusabbleElements) {
      const focusableEls = el.
        querySelectorAll('a[href], area[href],' +
          ' input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
      this.focusabbleElements = Array.prototype.slice.call(focusableEls);
      this.focusabbleElements[0].focus();
    }
  }

  handleError = (err) => {
    let isBusinessRuleError = false;
    if (err) {
      if (err.status === 400 || err.status === 500) {
        this.errorMessage = "Something went wrong. We couldn't process your request. Please try again later.";
        isBusinessRuleError = true;
      } else if (err.status === 401) {
        this.errorMessage = 'Session expired, Please login again.';
        logoutCurrentUser(true);
      } else {
        this.errorMessage = "Something went wrong. We couldn't process your request. Please try again later.";
      }
      this.utilityService.loadFocusOnTop();
    }
  }

  moveToEnrollment() {
    this.router.navigate(['/productselection']);
  }

  handleKeydown(event) {
    if (event.keyCode === ESCAPE_KEY) {
      this.btnAction(false);
      return;
    }
    this.utilityService.handleKeyPress(event, this.focusabbleElements);
  }

  checkAccess() {
    if (this.user.fanSignedUpStatus === 'SOME' || this.user.fanSignedUpStatus === 'ALL' || this.user.addpAuthority !== 'FULL') {
      this.hasAccess = true;
    }
  }

  back() {
    history.back();
  }
}
